import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { formatCurrency } from 'utils/formats';
import { TradingOfferPriceContext } from '../../../types/TradingOffer';

type TradingOfferPriceContextCardProps = {
  priceContext: TradingOfferPriceContext;
};

const TradingOfferPriceContextCard: FC<TradingOfferPriceContextCardProps> = ({
  priceContext,
}) => {
  const { t } = useTranslate();

  const priceItems = [
    {
      label: t('CurrentOfferPrice'),
      value: priceContext.currentOfferPrice,
      highlight: true,
    },
    {
      label: t('LastTransactionPrice'),
      value: priceContext.lastTransactionPrice,
    },
    {
      label: t('AvgSellOffersPrice'),
      value: priceContext.avgSellOffersPrice,
    },
    {
      label: t('OfficialValuation'),
      value: priceContext.officialValuation,
    },
    {
      label: t('YourAvgBuyPrice'),
      value: priceContext.userAvgBuyPrice,
    },
  ];

  const isCompetitivePrice =
    priceContext.currentOfferPrice <= priceContext.avgSellOffersPrice &&
    priceContext.currentOfferPrice > 0;

  return (
    <div className="card card-bordered">
      <div className="card-inner">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="card-title text-base mb-0">{t('PriceContext')}</h6>
          {isCompetitivePrice && (
            <span className="badge badge-dim badge-success">
              <em className="icon ni ni-check-circle mr-1" />
              {t('CompetitivePrice')}
            </span>
          )}
        </div>

        <ul className="nk-list-plain">
          {priceItems.map((item) => (
            <li
              key={item.label}
              className={`d-flex justify-content-between align-items-center py-2 ${
                item.highlight ? 'border-bottom border-light pb-3 mb-2' : ''
              }`}
            >
              <span className={`sub-text ${item.highlight ? 'fw-bold' : ''}`}>
                {item.label}
              </span>
              <span
                className={`lead-text ${
                  item.highlight ? 'text-primary fw-bold' : ''
                }`}
              >
                {formatCurrency(item.value)}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TradingOfferPriceContextCard;
